import type { GlobalApiInstitutionDetails } from '@data/global-api-institutions';

export const findMatchingInstitution = (
  institutions: GlobalApiInstitutionDetails[] | undefined,
  institutionId: string
) =>
  institutions?.find((institution) => institution.id === institutionId) ?? null;
